class EmptyResponseError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'EmptyResponseError';
	}
}

export default EmptyResponseError;
